module.exports = __webpack_public_path__ + "img/LogoFineday.15fb0f84.png";